export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/v2/landing-pages/_next/static/media/FollowIcon.4a0bda04.svg","height":20,"width":20};